import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Modal, Box} from '@material-ui/core';
import styles from './CommentFormModal.module.css';

const CommentFormModal = ({
  title,
  open,
  handleClose,
  rowsData,
  handleSubmit,
  lineBackgroundColor,
  reasons,
  agencies,
  cancelButtonText = 'Cancel',
  submitButtonText = 'Confirm',
}) => {
  const defaultReason = 'Select a Reason';
  const defaultAgency = 'Select an Agency';

  const [comment, setComment] = useState('');
  const [reason, setReason] = useState('');
  const [agency, setAgency] = useState('');
  const [error, setError] = useState(null);

  const Select = ({label, id, options, defaultOption, ...selectProps}) => {
    return (
      <div className={styles.defineRow}>
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
        <select
          id={id}
          className={clsx(styles.popupSelect, styles.vl3)}
          {...selectProps}
        >
          <option value={''} key={'default'}>
            {defaultOption}
          </option>
          {options.map(option => (
            <option value={option} key={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  };

  const handleSelectChangeCurry = setState => e => setState(e.target.value);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles.formContainer}>
          <div className={styles.formTitle}>
            <div>
              <span>({rowsData.length})</span>
              <span>{title}</span>
            </div>
            <div
              className={styles.formlLineDiv}
              style={{
                backgroundColor: lineBackgroundColor,
              }}
            />
          </div>
          <div className={styles.subHeading}>Note: *Mandatory fields</div>
          <Box bgcolor="#dadada3d" paddingTop="1px" paddingBottom="1px">
            <Select
              defaultOption={defaultReason}
              id="select-reason"
              name="Reason"
              label="Reason *"
              options={reasons}
              value={reason}
              onChange={handleSelectChangeCurry(setReason)}
            />
            <Select
              defaultOption={defaultAgency}
              id="select-agency"
              name="Agency"
              label="Agency *"
              options={agencies}
              value={agency}
              onChange={handleSelectChangeCurry(setAgency)}
            />
            <div className={styles.row}>
              <label className={clsx(styles.lb1, styles.selLabel)}>
                Comment
              </label>
              <textarea
                className={styles.textfield}
                value={comment}
                onChange={e => setComment(e.target.value)}
              ></textarea>
            </div>
            <div className={styles.errorText}>
              <em>{error}</em>
            </div>
          </Box>
          <div className={styles.bottomRow}>
            <button className={styles.cancelBt} onClick={handleClose}>
              {cancelButtonText}
            </button>
            <span>
              <button
                onClick={() => {
                  if (reason && agency) {
                    handleSubmit(rowsData, reason, agency, comment);
                    handleClose();
                  } else {
                    setError('*Reason and Agency are required');
                  }
                }}
                className={styles.submitBt}
              >
                {submitButtonText}
              </button>
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

CommentFormModal.propTypes = {
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  rowsData: PropTypes.arrayOf(
    PropTypes.shape({
      vc: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      market: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired,
      count: PropTypes.string.isRequired,
      fbv: PropTypes.string.isRequired,
    }),
  ),
  reasons: PropTypes.array.isRequired,
  agencies: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  lineBackgroundColor: PropTypes.string,
};

export default CommentFormModal;
